import { type FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '#components/IconButton'
import { TabularInformationOverlay } from '#components/tabularOverlay/TabularInformationOverlay'
import InfoIcon from '#icons/info-circle-outline-24.svg'
import { useSystemInformation } from './useSystemInformation'

export const SystemInformationOverlay: FC<{
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}> = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation('shared')
  const infoGroups = useSystemInformation()

  if (!isOpen) {
    return null
  }

  return (
    <TabularInformationOverlay
      title={t('system-information.title', 'System Information')}
      infoGroups={infoGroups}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  )
}

export const SystemInformationOverlayElements: FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation('shared')

  return (
    <>
      <IconButton iconUrl={InfoIcon} iconFirst className="_import" title={undefined} onClick={() => setIsOpen(true)}>
        {t('user.button.show-system-information', 'System Information')}
      </IconButton>
      {isOpen && <SystemInformationOverlay isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>
  )
}
